module.exports = __webpack_public_path__ + "img/EmptyPaper.655d67fc.png";